import { render, staticRenderFns } from "./ClaimCardWithDetails.vue?vue&type=template&id=ae126728&scoped=true"
import script from "./ClaimCardWithDetails.vue?vue&type=script&lang=js"
export * from "./ClaimCardWithDetails.vue?vue&type=script&lang=js"
import style0 from "./ClaimCardWithDetails.vue?vue&type=style&index=0&id=ae126728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae126728",
  null
  
)

export default component.exports